var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChangePassword(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#827c78"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22.706,
    cy: 22.196,
    r: 1.225
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#827c78",
    strokeWidth: 0.5,
    d: "M28.22 23.177c.677 0 1.225-.549 1.225-1.226v-4.533c0-2.702-2.198-4.9-4.9-4.9h-1.473V8.195C23.072 4.228 19.774 1 15.72 1 11.667 1 8.37 4.228 8.37 8.196v4.321H6.9C4.199 12.517 2 14.716 2 17.418v10.047c0 2.702 2.199 4.9 4.9 4.9h17.644c2.703 0 4.901-2.198 4.901-4.9 0-.677-.548-1.225-1.225-1.225s-1.225.548-1.225 1.225c0 1.351-1.1 2.45-2.45 2.45H6.9c-1.351 0-2.45-1.099-2.45-2.45V17.418c0-1.351 1.099-2.45 2.45-2.45h17.643c1.351 0 2.45 1.099 2.45 2.45v4.533c0 .677.55 1.226 1.226 1.226zm-7.599-10.66H10.82v-4.32c0-2.618 2.199-4.747 4.901-4.747 2.703 0 4.901 2.13 4.901 4.746v4.321z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.456,
    cy: 22.196,
    r: 1.225
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.861,
    cy: 22.196,
    r: 1.225
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.05,
    cy: 22.196,
    r: 1.225
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangePassword);
export default __webpack_public_path__ + "static/media/change-password.87d2798d7841f269b93f8d536c8c6c8d.svg";
export { ForwardRef as ReactComponent };